import AbstractAPI from '../common/AbstractAPI';
import { HTTPMethod } from '../common/Constants';
import SiteConstants from '../common/SiteConstants/SiteConstants';

class DetailsAPI extends AbstractAPI {
  static saveErrorReport(
    stockItemId: number,
    problem: string,
    description: string
  ) {
    const url =
      SiteConstants.buildInstance().getDetailsReportErrorBasePath() +
      stockItemId;

    const parameters = {
      error_option: problem,
      error_description: description,
    };

    return this.request(
      url,
      this.buildFetchOptions(HTTPMethod.POST, parameters)
    );
  }
}

export default DetailsAPI;
